module.exports = __webpack_public_path__ + "static/Nofiltr-X-Amazon-Prime-Day-Campaign-Report-5e4edb336bc5a592a3c333a69115a5e6.pdf";